import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const basePath = '/dealer/invite_user';

@Injectable({
  providedIn: 'root',
})

export class DealerInviteUserService {
  constructor(private http: HttpClient) {}

  // Sends or resends an invitation to a user to join the current dealer
  inviteUser(payload: { email: string }) {
    const body = payload;
    return this.http.post(`${basePath}`, body);
  }
  
}
